<template>
  <footer class="app-footer">
    <div ref="content" class="content">
      <div class="content-left">
        <logo-text class="logo" />
      </div>

      <div class="content-right">
        <a class="contact" :href="`mailto:${'FOOTER_CONTACT'.t()}`">
          {{"FOOTER_CONTACT".t()}}
        </a>
        <p class="copyright">{{"FOOTER_COPYRIGHT".t()}}</p>
      </div>
    </div>
  </footer>
</template>

<script>
import LogoText from './LogoText.vue';

export default {
  mounted() {
    let interSected = false;

    const observer = new IntersectionObserver(
    entries => 
    {
      entries.forEach(entry => {
        if (!interSected && entry.isIntersecting)
        {
          interSected = true;

           this.$anime({
            targets: [
              this.$refs.content.querySelectorAll(".logo"),
              // this.$refs.texts.querySelectorAll("svg, span"),
              this.$refs.content.querySelectorAll(".content-right")
            ],
            translateY: ["100%", 0],
            translateZ: 0,
            opacity: [0, 1],
            duration: 750,
            easing: "easeOutExpo",
            delay: (el, i) => 300 * i,
          });
        }
      });
    },
    {
      threshold: 0
    });
    observer.observe(this.$refs.content);
  },
  components: { LogoText },
}
</script>

<style scoped>
.app-footer {
  height: 26.6rem;
  background: #F3ECE6;
}

.content {
  display: flex;
  align-items: center;

  padding: 0 3.33rem;
  margin: 0 auto;
  max-width: 940px;
  width: 100%;
  height: 100%;
}

.content-left {
  display: flex;
  align-items: center;

  margin-right: auto;

  & .logo {
    width: 31.6rem;
    height: 5.1rem;
  }
}

.content-right {
  text-align: right;

  & .contact {
    font-weight: bold;
    font-size: 1.6rem;
    line-height: 120%;
    color: #7D6C60;
  }

  & .copyright {
    margin-top: 0.8rem;
    font-size: 1.6rem;
    line-height: 120%;
    color: #7D6C60;
  }
}

@media (max-width: 425px) {
  .app-footer {  
    height: 18.8rem;
  }

  .content {
    flex-direction: column;
    justify-content: center;
  }

  .content-left {
    margin: 0;

    & .logo {
      width: 22.8rem;
      height: 3.7rem;
    }
  }

  .content-right {
    margin-top: 2.1rem;
    text-align: center;

    & .contact {
      font-size: 1.2rem;
    }

    & .copyright {
      font-size: 1.2rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppFooter.vue